<template>
  <WdsLabel
    v-if="stageLabel"
    :xs="size === 'xs'"
    :sm="size === 'sm'"
    :md="size === 'md'"
    :lg="size === 'lg'"
    :primary="isPrimary"
    :success="isSuccess"
    :gray="isGray"
    :subtle="true"
    :data-test="dataTest"
  >
    {{ stageLabel }}
  </WdsLabel>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { WdsLabel } from '@worksome/wds-components'

import { JobCandidateHiringStep } from '@/gql/graphql'
import {
  COMPLETION_PHASE_STEPS,
  INTERVIEW_PHASE_STEPS,
  JobCandidateStepList,
  SELECTION_PHASE_STEPS,
} from '@/components/Job/constants'

// Accepts a plain string so server-rendered surfaces (Blade) can pass the
// GraphQL enum name through without importing the generated enum.
const props = withDefaults(
  defineProps<{
    step?: JobCandidateHiringStep | string | null
    size?: 'xs' | 'sm' | 'md' | 'lg'
    dataTest?: string
  }>(),
  { step: null, size: 'md', dataTest: undefined },
)

const step = computed<JobCandidateHiringStep | null>(() =>
  props.step && props.step in JobCandidateStepList
    ? (props.step as JobCandidateHiringStep)
    : null,
)

const stageLabel = computed(() => (step.value ? JobCandidateStepList[step.value].label : null))

const isPrimary = computed(
  () =>
    !!step.value &&
    (INTERVIEW_PHASE_STEPS.has(step.value) ||
      step.value === JobCandidateHiringStep.InvitedToApply ||
      step.value === JobCandidateHiringStep.Applied),
)

const isSuccess = computed(
  () =>
    !!step.value &&
    (COMPLETION_PHASE_STEPS.has(step.value) ||
      step.value === JobCandidateHiringStep.Hiring ||
      step.value === JobCandidateHiringStep.SelectionPresentedToClient),
)

const isGray = computed(
  () =>
    !!step.value &&
    ((SELECTION_PHASE_STEPS.has(step.value) &&
      step.value !== JobCandidateHiringStep.SelectionPresentedToClient) ||
      step.value === JobCandidateHiringStep.Shortlisted),
)
</script>
